import React from 'react'
import { scaleLinear, scaleBand } from 'd3-scale'
import { max } from 'd3-array'
import { line } from 'd3-shape'
import { format, svgHeight, svgWidth } from '../utils'

import { axisLeft, axisBottom } from 'd3-axis'

import AxisRenderer from './AxisRenderer'
import styled from 'styled-components'

const Bar = styled.rect`
  cursor: pointer;
  fill: steelblue;
  &:hover {
    fill: brown;
  }
`

const ContribBarChart = ({ margin, contentHeight, contentWidth, data, formatter }) => {
  const height = svgHeight(contentHeight, margin)
  const width = svgWidth(contentWidth, margin)

  const x = scaleBand()
    .rangeRound([0, width])
    .paddingInner(0.35)
    .paddingOuter(0.05)
    .domain(data.map(d => d.date))

  const y = scaleLinear()
    .rangeRound([height, 0])
    .domain([0, (Math.floor(max(data, d => d.value) / 5) + 1) * 5])

  const lineRenderer = line()
    .x(({ date }) => x(date) + x.bandwidth() / 2)
    .y(({ value }) => y(value))

  const xAxis = axisBottom(x)
  const yAxis = axisLeft(y).ticks(null, 's')

  const Path = styled.path`
    fill: none;
    stroke: orange;
    stroke-width: 3px;
  `
  const Dot = styled.circle`
    fill: white;
    stroke: brown;
    stroke-width: 5px;
  `

  const Text = styled.text`
    font-weight: bold;
    text-anchor: middle;
  `

  return (
    <svg width={contentWidth} height={contentHeight}>
      <g transform={`translate(${margin.left},${margin.top})`}>
        <AxisRenderer axis={yAxis} />
        <AxisRenderer dy={height} axis={xAxis} />
        {data.map(({ date, value }) => (
          <Bar
            key={`${date.toString()}-bar`}
            x={x(date)}
            y={y(value)}
            width={x.bandwidth()}
            height={height - y(value)}
          >
            <title>{`${date.toString()} : ${format(value, formatter)}`}</title>
          </Bar>
        ))}
        <Path d={lineRenderer(data)} />
        {data.map(({ date, value }) => (
          <g key={`${date.toString()}-indicator`}>
            <Dot cx={x(date) + x.bandwidth() / 2} cy={y(value)} r="8">
              <title>{`${date.toString()} : ${format(value, formatter)}`}</title>
            </Dot>
            <Text x={x(date) + x.bandwidth() / 2} y={y(value) - 15}>
              {format(value, formatter)}
            </Text>
          </g>
        ))}
      </g>
    </svg>
  )
}

export default ContribBarChart
